import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SendBirdChatComponent } from './sendbird-chat.component';
import { SendbirdChatService } from './sendbird-chat.service';

/**
 * 客服聊天室的 `@defer` 宿主，唯一職責是把 {@link SendBirdChatComponent} 切出 initial bundle。
 *
 * ## 為什麼需要這一層
 *
 * `<app-sendbird-chat>` 原本直接寫在 `basic-layout.component.html`，等於每一頁都掛著。
 * 它以 CSS class 控制顯示，因此**永遠會被實例化**，整棵 `layouts/sendbird-chat`
 * （首屏 77 KB）也就固定在 initial bundle 裡。
 *
 * `BasicLayoutComponent` 宣告於 NgModule，而 `@defer` 只有 standalone 宿主才會真的分包
 * （NgModule 宣告的元件其樣板相依來自 `NgModule.imports`，一律 eager，
 * 編譯器無從產生動態載入，且**不報錯**）。因此改用這個極小的 standalone 外殼。
 * 與 `wallet-connect-cta`、`chat-panel` 是同一個手法。
 *
 * ## 為什麼可以安全延後
 *
 * `SendBirdChatComponent.ngOnInit` 只做兩件事：訂閱 `displayChat$`、註冊
 * `beforeunload` 監聽。關閉狀態下它不執行任何實質工作 ——
 * 連線與訊息載入都在 `displayChat$` 轉為 true 之後才發生（見 `processInitSendBird`）。
 * 因此延後到「首次開啟」才載入，不會改變任何行為。
 *
 * 服務本身維持 eager：開啟聊天室的入口（左側選單、底部選單等）需要它，
 * 且 Sendbird SDK 早已在服務內部另行動態載入。
 */
@Component({
  selector: 'app-sendbird-chat-panel',
  standalone: true,
  imports: [CommonModule, SendBirdChatComponent],
  template: `
    @defer (when sendbirdChatService.displayChat$ | async) {
      <app-sendbird-chat></app-sendbird-chat>
    } @placeholder {
    } @error {}
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendbirdChatPanelComponent {
  constructor(public sendbirdChatService: SendbirdChatService) {}
}
